import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectStore = ({ expandedContainer }) => expandedContainer;

const makeSelectExpandedContainerOptions = () => createSelector(
  selectStore,
  (options) => ({ ...options }),
);

const makeSelectExpandedContainerOpened = () => createSelector(
  selectStore,
  ({ opened }) => opened,
);

const makeSelectExpandedContainerComponentType = () => createSelector(
  selectStore,
  ({ componentType }) => componentType,
);

export {
  makeSelectExpandedContainerOpened,
  makeSelectExpandedContainerOptions,
  makeSelectExpandedContainerComponentType,
};
